import { apiConfiguration } from './config';
import { apiClientNoBase } from '../../models/apiClient';

// Import generated API classes
import {
  AuthenticationApi,
} from './apis/authentication-api';
import { ArtistsApi } from './apis/artists-api';
import { FormsApi } from './apis/forms-api';
import { WorkflowsApi } from './apis/workflows-api';
import { UsersApi } from './apis/users-api';
import { LocationsApi } from './apis/locations-api';
import { ArtistImagesApi } from './apis/artist-images-api';
import { ArtistHerosApi } from './apis/artist-heros-api';
import { ArtistLocationsApi } from './apis/artist-locations-api';
import { TeamsApi } from './apis/teams-api';
import { TeamInvitesApi } from './apis/team-invites-api';
import { TeamReviewSettingsApi } from './apis/team-review-settings-api';
import { ProjectsApi } from './apis/projects-api';
import { FormSubmissionsApi } from './apis/form-submissions-api';

// Singletons with interceptors, no baseURL (use apiConfiguration.basePath)
export const authApi = new AuthenticationApi(apiConfiguration, undefined, apiClientNoBase);
export const artistsApi = new ArtistsApi(apiConfiguration, undefined, apiClientNoBase);
export const formsApi = new FormsApi(apiConfiguration, undefined, apiClientNoBase);
export const workflowsApi = new WorkflowsApi(apiConfiguration, undefined, apiClientNoBase);
export const usersApi = new UsersApi(apiConfiguration, undefined, apiClientNoBase);
export const locationsApi = new LocationsApi(apiConfiguration, undefined, apiClientNoBase);
export const artistImagesApi = new ArtistImagesApi(apiConfiguration, undefined, apiClientNoBase);
export const artistHerosApi = new ArtistHerosApi(apiConfiguration, undefined, apiClientNoBase);
export const artistLocationsApi = new ArtistLocationsApi(apiConfiguration, undefined, apiClientNoBase);
export const teamsApi = new TeamsApi(apiConfiguration, undefined, apiClientNoBase);
export const teamInvitesApi = new TeamInvitesApi(apiConfiguration, undefined, apiClientNoBase);
export const teamReviewSettingsApi = new TeamReviewSettingsApi(apiConfiguration, undefined, apiClientNoBase);
export const projectsApi = new ProjectsApi(apiConfiguration, undefined, apiClientNoBase);
export const formSubmissionsApi = new FormSubmissionsApi(apiConfiguration, undefined, apiClientNoBase);
